import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ["finishButton", "checkbox"]

  initialize() {
    window.addEventListener("load", () => {
      this.showHiddenTopics()
    })
  }

  showHiddenTopics() {
    this.checkboxTargets.forEach((checkbox) => {
      if (checkbox.checked && checkbox.getAttribute("data-nested-checkboxes-target") === "parent") {
        const topics = checkbox.parentElement.nextElementSibling
        if (topics && topics.classList.contains("collapse")) {
          topics.classList.remove("collapse")
          topics.classList.remove("-collapsed")
        }
      }
    })
    this.toggleFinishbutton()
  }

  check(event) {
    // If this checkbox is checked, then enable the button
    if (event.target.checked) {
      this.finishButtonTarget.removeAttribute("disabled")
      return
    }

    this.toggleFinishbutton()
  }

  toggleFinishbutton() {
    // Disable the button and check for any other checked checkboxes
    this.finishButtonTarget.setAttribute("disabled", true)

    const anyChecked = this.checkboxTargets.some((checkbox) => checkbox.checked)
    if (anyChecked) {
      this.finishButtonTarget.removeAttribute("disabled")
    }
  }
}
